import Common from "../../../Common";
import { TemplateType } from "../../../Enums";

export interface CompanyTemplateField {
	mobile: CompanyTemplateFieldMobileItem[]
	teams: CompanyTemplateFieldTeamsItem[]
}

export interface CompanyTemplateFieldMobileItem {
	id: id
	name: string
	added: string
	default_value: null | string
	description: string | null
	field_type: string
	field_type_value: null | string
	template_type: "mobile"
	category: string
}

export interface CompanyTemplateFieldTeamsItem {
	id: id
	name: string
	added: string
	default_value: null | string
	description: string | null
	field_type: string
	field_type_value: null | string
	template_type: "teams"
	category: string
}

const Field = class extends Common {
	// @ts-expect-error please i just want to build this project
	async browse(companyId: id, templateField?: TemplateType): CustomResponse<CompanyTemplateField> {
		return this.get(`/company/${companyId}/template/field${templateField ? `/${templateField}` : ''}`);
	}
}

export default Field;
